import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ManifestoAbout from "./sections/ManifestoAbout";
import LegalPartnerForBusinessCertainty from "./sections/LegalPartnerForBusinessCertainty";
import OurImpactInNumbers from "./sections/OurImpactInNumbers";
import OnzeGroeiformule from "./sections/OnzeGroeiformule";
import FeaturesInvestment from "./sections/FeaturesInvestment";
import KlantenAanHetWoord from "./sections/KlantenAanHetWoord";
import StartUwCirculaireReis from "./sections/StartUwCirculaireReis";
import Footer from "@/reusable_sections/Footer";
import CustomerReviews from "./sections/CustomerReviews";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <ManifestoAbout />
      <LegalPartnerForBusinessCertainty />
      <OurImpactInNumbers />
      <OnzeGroeiformule />
      <FeaturesInvestment />
      <CustomerReviews />
      <KlantenAanHetWoord />
      <StartUwCirculaireReis />
      <Footer />
    </div>;
}